import React from 'react';
import s from './MobileTerms.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import Secured from '../../../assets/icons/Secured.svg';
import Payment1 from '../../../assets/icons/Payment1.svg';
import Payment2 from '../../../assets/icons/Payment2.svg';
import Payment3 from '../../../assets/icons/Payment3.svg';
import Payment4 from '../../../assets/icons/Payment4.svg';
import DaysGuaranty from '../../../assets/icons/DaysGuaranty.svg';

export const MobileTerms: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <div className={s.strip} data-hook="mobile-terms">
      <div className={s.acceptedMethod}>
        {t('mobile.terms.acceptedMethods')}
        <div className={s.paymentMethods}>
          <img src={Payment1} alt="Visa" />
          <img src={Payment2} alt="Mastercard" />
          <img src={Payment3} alt="Amex" />
          <img src={Payment4} alt="Discover" />
        </div>
      </div>
      <div className={s.termHighlight}>
        <div className={s.guaranty}>
          <img src={DaysGuaranty} alt="Days Guaranty" />
          {t('mobile.terms.guaranty')}
        </div>
        <div className={s.secured}>
          <img src={Secured} alt="Secured" />
          {t('mobile.terms.secured')}
        </div>
      </div>
      <div className={s.termDescription}>{t('mobile.terms.description')}</div>
    </div>
  );
};

export default MobileTerms;
